import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatTabChangeEvent } from "@angular/material/tabs";
import { Subject, switchMap, take, takeUntil } from "rxjs";
import { Store } from "@ngrx/store";

import { selectorAuth, SessionStorageService } from "@app/core";
import { BusinessService } from "../business.service";
import { iconCodes } from "@app/shared/cqes-icon/cqes-icon.component";
import { ISpringResponseBody } from "@app/shared/interfaces/response-interfaces";
import { ParcelType } from "../business-models";
import { InfoService } from "@app/core/info/info.service";

@Component({
  selector: 'cloud-business-signing',
  templateUrl: './business-signing.component.html',
  styleUrls: ['./business-signing.component.scss']
})
export class BusinessSigningComponent implements OnInit, OnDestroy {

  private unsubscribe$ = new Subject<void>();
  readonly icons = iconCodes;
  isInitialLoadDone: boolean = false;
  hasSecondTabBeenSelected = false;
  canAccessRegisteredMail: boolean;

  constructor(
    private businessService: BusinessService,
    private sessionStorageService: SessionStorageService,
    private store: Store<any>,
    public info: InfoService,
  ) { }

  ngOnInit(): void {
    this.getCompanyData();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onTabChange(e: MatTabChangeEvent) {
    // Make fetch only the first time ( if it needs to do a request every time use: e?.index === 1; )
    if (e?.index === 1) {
      this.hasSecondTabBeenSelected = true;
    }
  }

  /**
   * Checks if the current user has access to registered mail services.
   * - Retrieves the company ID from session storage.
   * - Fetches user data from the store.
   * - Calls the service to check permissions for the user and company.
   * - Updates the `canAccessRegisteredMail` flag.
   */
  getCompanyData() {
    const companyCmrId = this.sessionStorageService.getItem("businessAccountId");

    this.store.select(selectorAuth).pipe(
      take(1), // Take the first emitted value and complete
      switchMap((userData) => {
        return this.businessService.getPermissionForCurrentUser(
          companyCmrId,
          userData?.userData?.cmrId
        );
      }),
      takeUntil(this.unsubscribe$)
    ).subscribe({
      next: (res: ISpringResponseBody) => {
        const permissions = res.data;
        this.canAccessRegisteredMail = permissions.some(service => service.serviceType === ParcelType.REGISTERED_DELIVERY);
        this.isInitialLoadDone = true;
      },
      error: (err) => {
        this.canAccessRegisteredMail = false;
        this.isInitialLoadDone = true;
        this.info.error(err.message);
      }
    });
  }
}
